import { millisecondsIn } from '@nova/core';

export const QUERY_DEFAULTS = {
  staleTime: 5 * millisecondsIn.minute,
  gcTime: 10 * millisecondsIn.minute,
  retryDelay: 1000,
  retryAttempts: 3
} as const;
